import { ConfigService } from 'src/app/services/config.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDataGridModule, DxRadioGroupModule, DxSwitchModule, DxToastModule } from 'devextreme-angular';
import { AppGlobals } from 'src/app/app.globals';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-config-wiki.page',
    imports: [CommonModule, DxRadioGroupModule, DxDataGridModule, DxSwitchModule, DxButtonModule, DxToastModule],
    templateUrl: './config-wiki.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./config-wiki.page.css']
})
export class ConfigWikiPageComponent implements OnInit {

  type: any = '';
  message: any = '';
  toastVisible: boolean = false;

  articleClearance: any;
  autoNumbering: any;

  //switchValue: boolean = false;

  selectedClearance: any;

  pageBreadCrumb: any = { text: $localize`Configuration/`, href: window.location.href, layer: 0 }

  constructor(private service: ConfigService, private appGlobals: AppGlobals) { }

  ngOnInit(): void {

/*     if (environment.isTestEnvironment === true) { */
      this.appGlobals.SetGlobalMenuIndex(8);
/*     } else {
      this.appGlobals.SetGlobalMenuIndex(7);
    } */


    AppGlobals.setBreadCrumbToLocalStorage(this.pageBreadCrumb);
    this.service.getWikiConfig({}).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.articleClearance = result.configItems;
        this.autoNumbering = this.articleClearance.pop();

        this.selectedClearance = this.articleClearance.find(item => item.value == true);
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  saveChangesClearance(e) {
    let idPrev = e.previousValue.id
    let idNewVal = e.value.id;

    let prev = this.articleClearance.find(item => item.id == idPrev);
    prev.value = false;

    let newVal = this.articleClearance.find(item => item.id == idNewVal)
    newVal.value = true;

    this.selectedClearance = e.value;

    let payLoad = this.articleClearance;

    this.service.writeWikiConfig({ ConfigItems: payLoad }).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if (this.type = 'success') {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastVisible = true;
  }

  saveChangesAutoNumbering(e) {

    this.autoNumbering.value = e.value;
    let payLoad = this.autoNumbering;

    this.service.writeWikiConfig({ ConfigItems: [payLoad] }).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }
}
